/* eslint-disable import/no-anonymous-default-export */
import React, { useContext } from "react";
import { Spinner, Dropdown, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faDashboard,
  faCalendarDays,
  faFolder,
  faSearch,
  faSignOut,
  faSignIn,
  faEllipsisV,
  faUserCog,
  faUser,
  faList,
  faXmarkCircle,
  faBell,
  faShareAltSquare,
} from "@fortawesome/free-solid-svg-icons";
import "./Sidebar.scss";
import { Link } from "react-router-dom";
import useSidebar from "./useSideMenu";
import CompleteProfileStep from "../../../_uiComponents/CompleteProfileStep";
import { AuthContext } from "../../../_hooks/useAuthContext";
export default ({ menuOpen, menuOpenHandler, activeMenuItem, handleResumeUploadModal, user, onShare }) => {
  const {
    onSignOutClick,
    loading,
    userMetaData,
    viewProfile,
    viewMentors,
    viewCandidates,
    viewDashboardClick,
    viewCalendarClick,
    viewAssessmentKitClick,
    onAssignedAssessmentClick,
    viewNotifications
  } = useSidebar();


  return (
    <div className={`sidebar shadow-sm  ${menuOpen ? "active" : ""}`}>
      <div className="logo d-flex justify-content-between border-bottom">
        <p className="mb-0" onClick={viewDashboardClick}>
          <img src="/assets/images/logo.svg" alt="logo" />
        </p>

        <button
          className="border-0 bg-transparent d-lg-none"
          onClick={() => menuOpenHandler()}
        >
          <FontAwesomeIcon icon={faXmarkCircle} className="h2 mb-0" />
        </button>
      </div>
      <div className="inner">
        <ul className="menu mt-2">
          <li>
            <p
              onClick={viewDashboardClick}
              className={`p-2 mb-0 cursor-pointer ${activeMenuItem === "home" ? "active" : ""
                }`}
            >
              <span className="icon mr-2">
                <FontAwesomeIcon icon={faDashboard} />
              </span>
              Dashboard
            </p>
          </li>
          {/* <li>
            <p
              onClick={() => viewJobBoard()}
              className={`p-2 mb-0 cursor-pointer${activeMenuItem === "jobs" ? "active" : ""
                }`}
            >
              <span className="icon mr-2">
                <FontAwesomeIcon icon={faBriefcase} />
              </span>
              Jobs
            </p>
          </li> */}

          {userMetaData && userMetaData?.role === "candidate" && (
            <li>
              <p
                onClick={() => onAssignedAssessmentClick()}
                className={`p-2 mb-0 cursor-pointer ${activeMenuItem === "Assessment Kit" ? "active" : ""
                  }`}
              >
                <span className="icon mr-2">
                  <FontAwesomeIcon icon={faList} />{" "}
                </span>
                Assigned Assessments
              </p>
            </li>
          )}  
          {userMetaData && userMetaData?.role !== "candidate" && (
            <>
              <li>
                <p
                  onClick={() => viewAssessmentKitClick()}
                  className={`p-2 mb-0 cursor-pointer${activeMenuItem === "Assessment Kit" ? "active" : ""
                    }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faFolder} />{" "}
                  </span>
                  Assessment Kits
                </p>
              </li>
              <li>
                <p
                  onClick={() => viewCalendarClick()}
                  className={`p-2 mb-0 cursor-pointer${activeMenuItem === "calendar" ? "active" : ""
                    }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faCalendarDays} />{" "}
                  </span>
                  Calendar
                </p>
              </li>
            </>
          )}
          {userMetaData?.role === "mentor" ? (
            <>
              {/* <li>
                <p
                  onClick={() => viewKanbanClick()}
                  className={`mb-0 p-2${activeMenuItem === "kanban" ? "active" : ""
                    }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faList} />{" "}
                  </span>
                  Kanban
                </p>
              </li> */}
              {/* <li>
                <p
                  onClick={() => viewAssessmentKit()}
                  className={`p-2 mb-0 cursor-pointer${activeMenuItem === "Assessment Kit" ? "active" : ""
                    }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faFolder} />{" "}
                  </span>
                  Assessment Kit
                </p>
              </li> */}

              {/* <li>
                <p
                  onClick={viewBucketListClick}
                  className={`p-2 mb-0 cursor-pointer ${
                    activeMenuItem === "bucket-list" ? "active" : ""
                  }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faBucket} />{" "}
                  </span>
                  Bucket List
                </p>
              </li> */}
            </>
          ) : null}
          {userMetaData?.role === "hiring_manager" ? (
            <>
              <li>
                <p
                  onClick={() => viewMentors()}
                  className={`p-2 mb-0 cursor-pointer${activeMenuItem === "mentor" ? "active" : ""
                    }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faUser} />{" "}
                  </span>
                  Mentors
                </p>
              </li>

              <li>
                <p
                  onClick={viewCandidates}
                  className={`p-2 mb-0 cursor-pointer${activeMenuItem === "candidate" ? "active" : ""
                    }`}
                >
                  <span className="icon mr-2">
                    <FontAwesomeIcon icon={faUserCog} />{" "}
                  </span>
                  Candidates
                </p>
              </li>
            </>
          ) : null}
          <li className="d-md-none">
            {userMetaData?.id ? (
              <p onClick={viewNotifications} className="p-0">
                <FontAwesomeIcon
                  icon={faBell}
                  className="icon mr-3 mt-1 cursor-pointer"
                /> Notifications
              </p>
            ) : null}
          </li>
        </ul>
      </div>
      <div className="bottom">
        {user &&
          <CompleteProfileStep user={user} handleResumeUploadModal={handleResumeUploadModal} onShare={onShare} />
        }
        <div className="user border-top d-flex">
          <div className="user-img">
            <img
              src={
                userMetaData?.user_meta_info &&
                  userMetaData.user_meta_info?.profile_image
                  ? userMetaData?.user_meta_info &&
                  userMetaData.user_meta_info?.profile_image
                  : "/assets/images/user.png"
              }
              alt="user"
              className="rounded-circle cursor-pointer user-image"
            />
          </div>
          <div className="content flex-grow-1">
            <p className="mb-0">{userMetaData?.full_name}</p>
            <p className="mb-0 text-gray">{userMetaData?.email}</p>
          </div>

          {userMetaData?.role !== "recruiter" &&
            <Dropdown as={ButtonGroup}>
              <Dropdown.Toggle
                variant=""
                split
                id="dropdown-split-basic"
                className="p-0 no-dropdown-arrow"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </Dropdown.Toggle>
              {userMetaData?.id ? (
                <Dropdown.Menu className="text-center">
                  <Dropdown.Item
                    onClick={viewProfile}
                    eventKey="option-1"
                    className="font-weight-medium"
                  >
                    {" "}
                    My Profile
                  </Dropdown.Item>

                  <button
                    onClick={onSignOutClick}
                    className="btn btn-primary d-flex justify-content-center align-items-center py-2  m-2 border-radius-10 mx-auto"
                  >
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center w-100">
                        <Spinner animation="border" variant="white" />
                      </div>
                    ) : (
                      <p className="mb-0">
                        <FontAwesomeIcon icon={faSignOut} className="mr-2" />
                        Logout
                      </p>
                    )}
                  </button>
                </Dropdown.Menu>
              ) : (
                <Dropdown.Menu>
                  <Link
                    href="/sign-in"
                    onClick={onSignOutClick}
                    className="btn btn-primary d-flex justify-content-center py-2  m-2 border-radius-10 align-items-center"
                  >
                    <FontAwesomeIcon icon={faSignIn} className="mr-2" /> SignIn
                  </Link>
                </Dropdown.Menu>
              )}
            </Dropdown>
          }
        </div>
      </div>
    </div>
  );
};
